<template>
  <li
    :class="
      isMobility ? 'date-pickers mobility' : 'date-pickers -borderless'
    "
  >
    <div class="flex-container">
      <div class="date-pickers__pickup">
        <label class="label">{{
          $t('components.booking.pickup')
        }}</label>
        <div class=" -sub">
          <date-picker
            :disabled="isPickupDateDisabled"
            :alert="pickUp.alert.date"
            :start-date="pickUp.openDatePickerDate"
            :availability="pickUp.disabledDates"
            :date-from-store="pickUp.dateFromStore"
            @date="selectedPickUpDate"
          />
          <selecter
            :active="isPickupDate"
            :alert="pickUp.alert.time"
            :simple-list="true"
            placeholder="hh:mm"
            :list-from-store="pickUp.hours"
            @item="selectedPickUpTime"
            :selected="pickUpTime"
          />
        </div>
      </div>
      <div class="date-pickers__drop">
        <label class="label">
          {{ $t('components.booking.drop') }}</label>
        <div class=" -sub">
          <date-picker
            :disabled="!isPickupTime"
            :alert="drop.alert.date"
            :availability="drop.disabledDates"
            :date-from-store="drop.dateFromStore"
            :start-date="pickUpDate"
            drop
            @date="selectedDropDate"
          />
          <selecter
            :active="isDropDate"
            :alert="drop.alert.time"
            :simple-list="true"
            placeholder="hh:mm"
            :list-from-store="drop.hours"
            @item="selectedDropTime"
            :selected="dropTime"
          />
        </div>
      </div>
    </div>
  </li>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import axios from 'axios'
import {
  getYear,
  getDay,
  getHours,
  parse,
  toDate,
  addMonths,
  addDays,
  isWeekend,
  isSameDay,
  setHours,
  isBefore,
  isSameHour,
  startOfDay,
  isLastDayOfMonth,
  startOfMonth,
} from 'date-fns'
import DatePicker from '../shared/inputs/DatePicker'
import Selecter from '../shared/inputs/Selecter'

export default {
  name: 'BookingDatePickers',
  props: {
    alertPickUpDate: {
      type: Boolean,
      default: false,
    },
    alertPickUpTime: {
      type: Boolean,
      default: false,
    },
    alertDropDate: {
      type: Boolean,
      default: false,
    },
    alertDropTime: {
      type: Boolean,
      default: false,
    },
    isMobility: {
      type: Boolean,
      default: false,
    },
    checkActive: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isDropValuesToClear: false,
      pickUp: {
        disabledDates: {
          days: [0],
          dates: [],
          to: new Date(),
          from: addMonths(new Date(), 4),
        },
        time: [],
        alert: {
          date: false,
          time: false,
        },
        dateFromStore: undefined,
        timeFromStore: undefined,
        openDatePickerDate: undefined,
        hours: [],
      },
      drop: {
        disabledDates: {
          days: [0],
          dates: [],
          to: new Date(),
        },
        time: {
          selected: '',
        },
        alert: {
          date: false,
          time: false,
        },
        dateFromStore: undefined,
        timeFromStore: undefined,
        hours: [],
      },
      holidays: {
        data: '',
      },
    }
  },
  components: {
    DatePicker,
    Selecter,
  },
  async mounted() {
    this.checkLocalStorage()
    await this.disableHolidays()
    this.setPickerOpenDate()
  },
  watch: {
    pickUpDate() {
      this.updateDropConstraints()
      this.updateHoursConstraints()
    },
    pickUpTime() {
      this.updateDropConstraints()
      this.updateHoursConstraints()
      if (!this.isDropHourAvailable) {
        this.selectedDropDate(null)
        this.selectedDropTime('')
      }
    },
    dropDate() {
      this.updateHoursConstraints()
    },
    alertPickUpDate(val) {
      this.pickUp.alert.date = !!val
    },
    alertPickUpTime(val) {
      this.pickUp.alert.time = !!val
    },
    alertDropDate(val) {
      this.drop.alert.date = !!val
    },
    alertDropTime(val) {
      this.drop.alert.time = !!val
    },
    pickUpBusiness: {
      handler() {
        this.disableWeekends()
        this.updateHoursConstraints()
        this.setPickerOpenDate()
      },
      deep: true,
    },
    dropBusiness: {
      handler() {
        this.disableWeekends()
        this.updateHoursConstraints()
      },
      deep: true,
    },
    checkActive(newVal) {
      if (newVal === false) {
        this.$store.commit('booking/SET_PICKUP_TIME', null)
        this.pickUp.dateFromStore = null
      }
    },
  },
  computed: {
    ...mapState({
      oneWay: (state) => state.booking.oneWay,
      pickUpBusiness: (state) => state.booking.pickUp.business,
      pickUpDate: (state) => state.booking.pickUp.date,
      pickUpTime: (state) => state.booking.pickUp.time,
      dropBusiness: (state) => state.booking.drop.business,
      dropDate: (state) => state.booking.drop.date,
      dropTime: (state) => state.booking.drop.time,
    }),
    ...mapGetters({
      isSameDayDrop: 'booking/isSameDayDrop',
    }),
    isDropHourAvailable() {
      if (this.isSameDayDrop && !this.isMorningPickUp) {
        return false
      }
      return this.pickupValuesOk && true
    },
    pickupValuesOk() {
      return this.pickUpDate && this.pickUpTime
    },
    isMorningPickUp() {
      return this.pickupValuesOk && parseInt(this.pickUpTime, 10) <= 11
    },
    isPickupDateDisabled() {
      if (this.oneWay) {
        return !(this.dropBusiness && this.pickUpBusiness)
      }
      return !this.pickUpBusiness
    },
    isPickupDate() {
      return !!this.pickUpDate
    },
    isPickupTime() {
      return !!this.pickUpTime
    },
    isDropDate() {
      return !!this.dropDate
    },
    returnDateFrom() {
      if (isLastDayOfMonth(this.pickUpDate) && !this.isMorningPickUp) {
        return startOfMonth(addMonths(this.pickUpDate, 1))
      }
      return this.pickUpDate
    },
  },
  methods: {
    checkLocalStorage() {
      this.checkLocalPick()
      if (this.pickupValuesOk) {
        this.checkLocalDrop()
      }
    },
    checkLocalPick() {
      this.checkLocalStorageFor(
        'rentPickupDate',
        'pickUp',
        'dateFromStore',
        'SET_PICKUP_DATE',
        true,
      )
      this.checkLocalStorageFor(
        'rentPickupTime',
        'pickUp',
        'timeFromStore',
        'SET_PICKUP_TIME',
      )
    },
    checkLocalDrop() {
      this.checkLocalStorageFor(
        'rentDropDate',
        'drop',
        'dateFromStore',
        'SET_DROP_DATE',
        true,
      )
      this.checkLocalStorageFor(
        'rentDropTime',
        'drop',
        'timeFromStore',
        'SET_DROP_TIME',
      )
    },
    checkLocalStorageFor(
      localStorageItem,
      step,
      dataKey,
      commitName,
      isDate,
    ) {
      let local = localStorage.getItem(localStorageItem)
      if (!local) {
        return
      }
      if (isDate) {
        local = new Date(local)
      }
      this[step][dataKey] = local
      this.$store.commit(`booking/${commitName}`, local)
    },
    selectedPickUpDate(val) {
      this.$store.commit('booking/SET_PICKUP_DATE', val)

      if (this.isDropValuesToClear) {
        // clean pick up time, drop date and time if user
        this.$store.commit('booking/SET_PICKUP_TIME', null)
        this.drop.dateFromStore = ''
        this.$store.commit('booking/SET_DROP_TIME', null)
      }
      this.isDropValuesToClear = true
    },
    selectedPickUpTime(val) {
      const pickTime = typeof val === 'string' ? val : val.value
      this.$store.commit('booking/SET_PICKUP_TIME', pickTime)
      if (
        this.dropDate === null
                || this.dropDate === ''
                || this.drop.dateFromStore === ''
      ) {
        let getSaturday = new Date(this.pickUpDate)
        getSaturday.setDate(getSaturday.getDate() + 1)
        const result = getSaturday.getDay() === 6
          ? (getSaturday = null)
          : new Date(getSaturday.setDate(getSaturday.getDate()))
        this.drop.dateFromStore = result
        this.$store.commit('booking/SET_DROP_DATE', result)
        this.drop.timeFromStore = pickTime
        this.$store.commit('booking/SET_DROP_TIME', pickTime)
      }
    },
    selectedDropDate(val) {
      this.drop.dateFromStore = val
      this.$store.commit('booking/SET_DROP_DATE', val)
    },
    selectedDropTime(val) {
      const dropTime = typeof val === 'string' ? val : val.value
      this.$store.commit('booking/SET_DROP_TIME', dropTime)
    },
    async disableHolidays() {
      try {
        const holidays = await axios.get('/api/holidays?format=n-j')
        const apiHolidays = holidays.data.data
        const holidaysDates = apiHolidays.reduce(
          (acc, holidayMonthDay) => [
            ...acc,
            toDate(
              parse(
                `${getYear(new Date())}-${holidayMonthDay}`,
                'yyyy-M-d',
                new Date(),
              ),
            ),
            toDate(
              parse(
                `${getYear(new Date()) + 1}-${holidayMonthDay}`,
                'yyyy-M-d',
                new Date(),
              ),
            ),
          ],
          [],
        )

        this.pickUp.disabledDates.dates = [
          ...this.pickUp.disabledDates.dates,
          ...holidaysDates,
        ]

        this.drop.disabledDates.dates = [
          ...this.drop.disabledDates.dates,
          ...holidaysDates,
        ]
      } catch (error) {
        console.error(error)
      }
    },
    disableWeekends() {
      if (!this.pickUpBusiness) {
        return
      }
      if (this.pickUpBusiness.opening_hours.closed_on_weekend) {
        this.pickUp.disabledDates.days = [6, 0]
      } else {
        this.pickUp.disabledDates.days = [0]
      }
      if (!this.oneWay) {
        this.drop.disabledDates.days = [
          ...this.pickUp.disabledDates.days,
        ]
        return
      }
      if (
        this.dropBusiness
                && this.dropBusiness.opening_hours.closed_on_weekend
      ) {
        this.drop.disabledDates.days = [6, 0]
      } else {
        this.drop.disabledDates.days = [0]
      }
    },
    updateDropConstraints() {
      this.drop.disabledDates.to = this.pickUpDate
      this.drop.disabledDates.from = addMonths(this.pickUpDate, 1)
      if (
        !this.isMorningPickUp
                || (this.dropDate && !this.drop.hours.length)
      ) {
        this.drop.disabledDates.to = addDays(this.pickUpDate, 1)
      }
    },
    updateHoursConstraints() {
      if (
        !this.pickUpBusiness
                || !this.pickUpBusiness.opening_hours
                || !this.pickUpBusiness.opening_hours.hours
      ) {
        return
      }

      const pickUpDateBasis = isWeekend(this.pickUpDate)
        ? 'weekend'
        : 'week'
      const now = new Date()
      const isPickupIsFollowingCurrentDay = isSameDay(
        addDays(now, 1),
        this.pickUpDate,
      )
      const currentHour = getHours(now)

      const afternoonPickupOpenHour = pickUpDateBasis === 'weekend'
        ? this.pickUpBusiness.houre_week_end_afternoone_open
        : this.pickUpBusiness.houre_week_afternoone_open

      if (isPickupIsFollowingCurrentDay) {
        this.pickUp.hours = currentHour > 14
          ? this.pickUpBusiness.opening_hours.hours[
            pickUpDateBasis
          ].filter((hour) => this.isHourBeforeOrSameHourPredicate(
            afternoonPickupOpenHour.split(':')[0],
            hour.split(':')[0],
          ))
          : this.pickUpBusiness.opening_hours.hours[
            pickUpDateBasis
          ]
      } else {
        this.pickUp.hours = this.pickUpBusiness.opening_hours.hours[
          pickUpDateBasis
        ]
      }

      if (this.dropDate) {
        const dropDateBasis = isWeekend(this.dropDate)
          ? 'weekend'
          : 'week'

        if (this.oneWay && this.dropBusiness) {
          this.drop.hours = this.dropBusiness.opening_hours.hours[
            dropDateBasis
          ]
        } else {
          this.drop.hours = this.pickUpBusiness.opening_hours.hours[
            dropDateBasis
          ]
        }
      }

      if (!this.isSameDayDrop) {
        return
      }
      this.drop.hours = this.drop.hours.filter(
        (hour) => parseInt(hour, 10) >= 14,
      )
    },
    isHourBeforeOrSameHourPredicate(baseH, toCompareH) {
      const baseHour = setHours(new Date(), baseH)
      const toCompareHour = setHours(new Date(), toCompareH)
      return (
        isBefore(baseHour, toCompareHour)
                || isSameHour(baseHour, toCompareHour)
      )
    },
    setPickerOpenDate() {
      let pickerOpenDate = addDays(startOfDay(new Date()), 1)
      let isInvalidDate = this.isInvalidDateForPicker(pickerOpenDate)

      while (isInvalidDate) {
        pickerOpenDate = addDays(pickerOpenDate, 1)
        isInvalidDate = this.isInvalidDateForPicker(pickerOpenDate)
      }

      this.pickUp.openDatePickerDate = pickerOpenDate
    },
    isInvalidDateForPicker(pDate) {
      return (
        getDay(pDate) === 0 // sunday
                || (getDay(pDate) === 6
                    && this.pickUpBusiness
                    && this.pickUpBusiness.opening_hours.closed_on_weekend) // saturday and business closed on weekend
                || this.isDateInArray(this.pickUp.disabledDates.dates, pDate)
      ) // bank holiday
    },
    isDateInArray(sourceArray, inputDate) {
      const source = [...sourceArray.map((d) => d.toISOString())]
      return source.includes(inputDate.toISOString())
    },
  },
}
</script>

<style scoped lang="scss">

.date-pickers {
  display: flex;
  justify-content: space-between;

  &__drop,
  &__pickup {
    max-width: calc(50% - 16px);

    @include teq-breakpoint($large) {
      max-width: 50%;
    }
  }

  .-sub {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;

    @include teq-breakpoint($large) {
      flex-direction: row;
    }
  }

  &__pickup {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-items: flex-end;
    position: relative;

    &::before {
      background: $lt-gray;
      bottom: auto;
      height: 13rem;
      position: absolute;
      right: -1.6rem;
      top: 0;
      width: 1px;

      @include teq-breakpoint($large) {
        background: #000;
        content: '';
        height: 2px;
        right: -1.4rem;
        top: 60%;
        width: 6px;
      }
    }
  }

  &__drop {
    display: flex;
    flex: 0 1 calc(50%);
    flex-direction: column;
    justify-items: flex-end;

    div {
      display: flex;
      flex: 1;
      margin-bottom: 10px;

      &.inactive {
        color: #000;
        pointer-events: none;
      }
    }
  }
}

p {
  @include font-size(16px);

  color: white;
  font-family: $f-graphie-book;
  margin-bottom: 0;
}

.mobility {
  .label {
    color: black;
    display: block;
    font-family: $f-graphie-book;
    font-size: 1.6rem;
    line-height: 1;
    margin-bottom: 1.2rem;
    width: 100%;
  }

  .flex-container {
    display: flex;
    flex-wrap: wrap;
    //justify-content: space-between;
    gap: 2rem;
    width: 100%;
  }

  .date-pickers {
    box-sizing: border-box;
    justify-content: space-between;
    padding: 1.5rem 2rem 0;

    @include teq-breakpoint($medium) {
      padding: 3rem 2rem 0;
    }

    @include teq-breakpoint($large) {
      padding: 2rem 2rem 1.5rem;
    }

    @include teq-breakpoint($wide) {
      padding: 3rem 3rem 1.5rem;
    }

    &__drop,
    &__pickup {
      .flex-container {
        flex-direction: column;
        //justify-content: space-between;
        max-width: 100%;

        @include teq-breakpoint($large) {
          flex-direction: row;

          //justify-content: space-between;
        }
      }
    }

    .date-picker {
      background: $lt-gray;
      margin-bottom: 0.9rem;
      width: 100%;

      @include teq-breakpoint($medium) {
        min-width: 100%;
      }

      ::placeholder {
        color: #878785;
      }

      input {
        background-color: $lt-gray;
      }

      @include teq-breakpoint($large) {
        margin-bottom: 0;
        max-width: 100%;
        min-width: auto;
        width: 100%;
      }
    }

    .selecter {
      color: #000;
      margin-bottom: 0;

      @include teq-breakpoint($large) {
        max-width: calc(45% - 0.5rem);
        width: calc(45% - 0.5rem);
      }

      select {
        background-color: $lt-gray;
        color: #000;
        text-align: center;
        width: 100%;
      }

      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
